import styled from 'styled-components';

import { Markdown as MarkdownDisplay } from '../markdown';
import { paragraph, spacedHeading } from '../../../theme/typography';
import { Content } from '../../../theme/layout';
import { media } from '../../../theme/media';

export const ContentWrapper = styled(Content)`
  padding-top: 56px;
  padding-bottom: 104px;
  ${media.tablet`
    padding-bottom: 80px;
  `};
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Title = styled.h1`
  ${spacedHeading};
`;

export const Markdown = styled(MarkdownDisplay)`
  ${paragraph};
  max-width: 636px;
  text-align: left;

  h1 + p,
  h2 + p,
  h3 + p,
  h4 + p {
    padding-top: 16px;
  }

  ul,
  p {
    padding-top: 8px;
    padding-bottom: 8px;
  }
`;
